<template>
	<div>
		<div class="item-section rounded-lg overflow-hidden shadow bg-white">
			<div class="header_products px-4 pt-4 pb-2">
				<span class="section-title">{{ $root.getLangText(item.title) }}</span>
			</div>
			<div class="h-64 overflow-hidden" v-if="item.image">
				<img class="w-full" v-lazy="getLasyImage($root.getImage(item.image))" alt="" >
			</div>
			<div class="px-4 pt-2 pb-4 section section-description" v-if="hasDescrSection(item)">
				<div>
					<div v-html="$root.getLangText(item.descr)"></div>
				</div>
				<div  v-if="item.files && item.files.length > 0">
					<div class="text-xs flex justify-end items-center mt-2" v-for="file in item.files"  :key="file">
						<a :href="$root.getFile($root.getLangText(file.files))" v-if="$root.getImage($root.getLangText(file.files)).length > 0" class="product_add_cart flex items-center justify-center rounded-full flex-shrink-0 h-8 px-2 min-w-[8rem] text-sm text-center text-white uppercase" style="color: #fff !important;" target="_blank">
							{{ file.title.length === 0 ? $root.getKeyWord('download') : $root.getLangText(file.title) }}
						</a>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>

export default {
  	name: 'app_article_section',
  	props: ['item'],

	computed: {
		image() {
			let descr = this.$root.getLangText(this.item.descr);
			var re = /<img[^>]+src="?([^"\s]+)"?\s*\/>/g;
			var results = re.exec(descr);
			var firstImage = "";
			if(results) firstImage = results[1];

			return (this.item.background_image) ? this.item.background_image : firstImage;
		}
	},

	methods: {
		
		getLasyImage(src) {
			let lazyImgObj = {
				src: src,
				error: require(`@/assets/image/loading_product.svg`),
				loading: require(`@/assets/image/loading_product.svg`)
			};

			return lazyImgObj;
		},

		hasDescrSection(section) {
			var descr = section.descr;

			if (section.files && section.files.length > 0)
				return true;
			if (descr === null)
				return;
			let check_descr = descr[this.$root.currentLanguage];
			if (!check_descr || check_descr === undefined)
				return false;
			if (check_descr.indexOf('img') > -1)
				return true;

			return (check_descr !== undefined && this.$root.stripTags(check_descr).length > 0);
		},		
	}
}
</script>
<style>
	.section img {
		width: 100%;
	}
	div.section a{
		text-decoration: underline;
		color: blue;
	}
	div.section a.product_add_cart {
		color: #fff;
		text-decoration: none;
	}

	.section-description ol {
		list-style: decimal!important;
		padding-left: 30px;
		margin-top: 5px;
	}

</style>